export default __webpack_public_path__ + "static/media/salesTeam.fc215b51.svg";